export default __webpack_public_path__ + "static/media/type-modal.b107f11d.svg";